<template>
  <v-content>
    <v-container
      v-if="!submitting"
      grid-list-lg
    >
      <v-layout
        wrap
        row
      >
        <!-- errors -->
        <v-flex
          v-if="errors.length"
          xs12
        >
          <b>Please correct the following error(s):</b>
          <ul>
            <li
              v-for="error in errors"
              :key="error.id"
            >
              {{ error }}
            </li>
          </ul>
        </v-flex>

        <!-- ユーザープロフィール -->
        <v-flex
          xs12
          md4
        >
          <h2>プロフィール</h2>
          <v-card v-if="user">
            <v-card-text>
              <div>
                <v-text-field
                  v-model="user.data.name"
                  placeholder="名前"
                />
              </div>
            </v-card-text>
          </v-card>
          <v-progress-circular
            v-else
            :size="50"
            color="primary"
            indeterminate
          />
        </v-flex>

        <!-- 脱出記録 -->
        <v-flex
          xs12
          md7
          offset-md1
        >
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <h2>脱出記録を追加</h2>
              <v-card>
                <v-card-text>
                  <p>参加した/する脱出ゲームを選択し「追加」を押すと「脱出記録一覧」に追加されます。</p>
                  <v-combobox
                    v-model="escapeStrings"
                    :items="escapes.flatMap(e => [e.data.name])"
                    hide-selected
                    multiple
                    small-chips
                  />
                  <v-btn
                    block
                    color="primary"
                    @click="addEscapesToResults(selectedEscapes)"
                  >
                    追加
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              xs12
            >
              <h2>脱出記録一覧</h2>
              <v-layout
                v-if="Array.isArray(results) && results.length > 0" 
                row
                wrap
              >
                <v-flex
                  v-for="result in results"
                  :key="result.id"
                  xs12
                >
                  <v-card>
                    <v-card-title>
                      <h3 v-if="result.escape">
                        {{ result.escape.data.name }}
                      </h3>
                      <h3 v-else>
                        情報取得中...
                      </h3>
                    </v-card-title>
                    <v-card-text>
                      <v-menu
                        v-if="result.escape"
                        v-model="menu[result.escape.data.name]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="result.joinedAt"
                            label="脱出参加日"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="result.joinedAt"
                          @input="menu[result.escape.data.name] = false"
                        />
                      </v-menu>
                      <v-checkbox
                        v-model="result.data.success"
                        :label="`${result.data.success ? '脱出成功' : '脱出失敗'}`"
                      />
                      <v-btn
                        block
                        color="warning"
                        @click="deleteResult(result)"
                      >
                        削除
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <div v-else-if="Array.isArray(results) && results.length == 0">
                <p>脱出履歴がありません。</p>
              </div>
              <v-progress-circular
                v-else
                :size="50"
                color="primary"
                indeterminate
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- 保存 -->
      <v-btn
        right
        bottom
        fixed
        color="primary"
        @click="submit"
      >
        <v-icon dark>
          save
        </v-icon>
        保存
      </v-btn>
    </v-container>
    <v-container v-else>
      提出中
    </v-container>
  </v-content>
</template>

<script>
  import * as http from "@/escape-be/http";
  import UserRepository from "@/repository/user";
  import ResultRepository from "@/repository/result";
  import EscapeRepository from "@/repository/escape";

  export default {
    name: "Edit",
    data() {
      return {
        escapeStrings: [],
        errors: [],
        user: null,
        results: null,
        escapes: [],
        menu: {},
        submitting: false
      };
    },
    computed: {
      selectedEscapes() {
        return this.escapeStrings.flatMap(this.toEscape)
      }
    },
    async mounted() {
      this.user = await UserRepository
        .findOne(this.$route.params.userId)
        .catch(e => this.errors.push(...[e].flat()));
      
      this.results = await ResultRepository
        .findByUser(this.user)
        .catch(e => this.errors.push(...[e].flat()));

      this.results.forEach(async r => {
        await EscapeRepository
          .findByRef(r.data.escapeRef)
          .then(e => this.$set(r, "escape", e))
          .catch(e => this.errors.push(...[e].flat()))
      });

      this.escapes = await EscapeRepository
        .findAll()
        .catch(e => this.errors.push(...[e].flat()));

    },
    beforeDestroy() {
      ResultRepository.reset()
    },
    methods: {
      toEscape: function(s) {
        return this.escapes.flatMap(e => e.data.name === s ? [e] : [])
      },
      submit: async function() {
        this.submitting = true
        // setにもdeleteにも入っていないresultはupdateする
        await ResultRepository.commit(this.user, this.results)
        this.$router.push({ path: `/users/${this.user.id}`})
      },
      addEscapeToResult: function(escape) {
        if (this.results.flatMap(r => [r.escape.id]).includes(escape.id)) {
          return
        }
        let result = {
          data: {
            escapeRef: escape.ref,
            success: false,
          },
          escape: escape
        };
        this.results.push(result)
        ResultRepository.addReserve(result)
      },
      addEscapesToResults: function(escapes) {
        escapes.forEach(e => this.addEscapeToResult(e));
        this.escapeStrings = []
      },
      deleteResult: function(result) {
        let index = this.results.flatMap(r => [r.id]).indexOf(result.id)
        if (index === -1) {
          return
        }
        this.results.splice(index, 1)
        ResultRepository.deleteReserve(result)
      }
    }
  }
</script>
